import type { VisionSearchParams } from "@/routes/-search-params";
import { platformApi } from "@/services";

type PartnerResolutionSearch = Pick<VisionSearchParams, "partnerCode" | "partnerToken" | "locationId">;

export async function resolvePartnerFromSearch(search: PartnerResolutionSearch): Promise<string | null> {
	if (search.partnerCode) {
		return search.partnerCode;
	}

	if (search.partnerToken) {
		const tokenResponse = await platformApi.logInWithPartnerToken(search.partnerToken);
		return tokenResponse.partner_code;
	}

	if (search.locationId) {
		const locationData = await platformApi.getLocationAndPartner(search.locationId);
		return locationData.Partner.code;
	}

	return null;
}
